import { useState, useEffect } from "react";
import AppHeader from "./../../../components/common/appHeader/AppHeader";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import { setMealType } from "@src/@slice/recommendHallSlice";
import Blank from "../../../components/common/blank/Blank";

import buffet from '@assets/images/recommend/weddinghall/meal_buffet.jpg';
import course from '@assets/images/recommend/weddinghall/meal_course.jpg';
import table from '@assets/images/recommend/weddinghall/meal_table.jpg';
import ImageSelectableCard from "@src/components/recommend/ImageSelectableCard";

const mealTypeItems = [
  {title:"뷔페", subTitle: '다양한 메뉴를 개인이 선택', src:buffet, },
  {title:"코스", subTitle: '차례로 나오는 고급 메뉴들', src:course, },
  {title:"한상차림", subTitle: '한상에 정갈하게 차린 식사', src:table, },
];


const MealType = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const { hallData, dispatch } = useRecommendHall();
  useEffect(() => {
    setValidate(hallData.meal.types.length > 0);
  }, [hallData.meal.types]);
  useEffect(() => {
    if (
      hallData.hallStyleTypes.length === 0 ||
      hallData.weddingType === "" ||
      hallData.weddingRegions.length === 0 ||
      (hallData.expectedPerson.min === null && hallData.expectedPerson.max === null)
    ) {
      navigate("/recommend/hall/start", { replace: true });
    }
  }, []);
  const goNext = () => {
    navigate("/recommend/hall/cost");
  };
  return (
    <div>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      {/* <div className="layout-fix-button with-app-header"> */}
      <div className="hall-recommend-layout-fix-button">
        <div style={{paddingBottom:'50px'}}>
          <PageTitle
            title={`선호하는 식사 형태를
						모두 선택해 주세요.`}
            type=""
          />
          <div className="common-wrap">
            <div style={{ height: 20 }} />
             <div className="hall-recommend-grid-layout columns-2">
              {mealTypeItems.map((type) => (
                <ImageSelectableCard 
                  key={`style-item-${type.title}`} 
                  src={type.src} 
                  checked={hallData.meal.types.indexOf(type.title)> -1}
                  onClick={()=> dispatch(setMealType({type:type.title}))}
                />
              ))}
            </div>
          </div>
        </div>
        <div>
          <div className="btn-wrap gradient">
            <button
              onClick={goNext}
              className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
              disabled={!validate}
            >
              다음
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MealType;
